const initialStateES = {
  // PERSONAL INFORMATION
  firstName: '',
  middleName: '',
  lastName: '',
  dateOfBirth: '',
  gender: '',

  // OCR FILE NAMES
  fileNames: {
    file1: '',
    file2: '',
  },

  // CURRENT RESIDENTIAL ADDRESS
  streetAddress: '',
  city: '',
  state: '',
  postCode: '',

  // CONTACT DETAILS
  phoneNo: '',

  // REPORTING REFERENCE NUMBER
  reportingReference: '',

  // ERROR HANDLING
  errors: {},
};

export default initialStateES;
